import { Stack, Typography, useTheme } from "@mui/material";
import { Check } from "lucide-react";
import type { FC } from "react";
import { useGoalsRightOptional } from "web_myplann/Api/Rights/RightsProvider";
import { FinanceDialog } from "web_myplann/Dashboard/Components/FinanceDialog";
import { IconBox } from "web_myplann/Shared/Components/IconBox";
import {
	GRASS_GREEN_MYPLANN,
	LIGHT_GREEN_MYPLANN,
} from "web_myplann/Utils/constants";

type Props = {
	open: boolean;
	onClose: () => void;
	title: string;
	description: string;
	closeOnBackdropClick?: boolean;
};

export const LeadSentDialog: FC<Props> = ({
	open,
	onClose,
	title,
	description,
	closeOnBackdropClick,
}) => {
	const theme = useTheme();
	const hasGoalsRight = useGoalsRightOptional();
	const textColor = hasGoalsRight
		? undefined
		: theme.palette.deprecated.grey[700];
	const iconBg = hasGoalsRight ? theme.palette.green[100] : LIGHT_GREEN_MYPLANN;
	const iconColor = hasGoalsRight
		? theme.palette.realization.main
		: GRASS_GREEN_MYPLANN;

	return (
		<FinanceDialog
			onClose={onClose}
			open={open}
			autoFadeOut
			closeOnBackdropClick={closeOnBackdropClick}
		>
			<Stack
				p={hasGoalsRight ? theme.spacingTokens.xl : 2.4}
				alignItems="center"
				gap={hasGoalsRight ? theme.spacingTokens.xl : 2.4}
			>
				<IconBox bg={iconBg} shape="circle" size={48}>
					<Check size={theme.iconSize.lg} color={iconColor} />
				</IconBox>
				<Stack gap={theme.spacingTokens.sm} textAlign="center">
					<Typography
						variant={hasGoalsRight ? "h3" : "deprecatedH3"}
						color={textColor}
					>
						{title}
					</Typography>
					<Typography
						variant={hasGoalsRight ? "body2" : "deprecatedBody1"}
						color={textColor}
					>
						{description}
					</Typography>
				</Stack>
			</Stack>
		</FinanceDialog>
	);
};
